import React from "react";

import { FILE_UPLOAD_STATUS } from "constants/constants";
import Loader from "shared/Loader/Loader";
import { useFetchHistory, useFetchProcessedFile } from "store/backend/apiHooks";
import { PrimaryButton, Table } from "widgets";
import tokenUtils from "utils/tokenUtils";
import { useSnackbarContext } from "widgets/SnackBar/SnackBar";

import styles from "./FileUploadsHistory.module.scss";

const columns = [
  { label: "Name", field: "name" },
  { label: "Created At", field: "createdAt" },
  { label: "Total Rows", field: "totalRows" },
  { label: "Error Rows", field: "errorRows" },
  { label: "Status", field: "status" },
  { label: "Download Processed File ", field: "downloadProcessedFile" },
];

const handleOnClickDownloadProcessedFile = (
  fileId,
  fetchProcessedFile,
  openSnackbar
) => {
  if (fileId) {
    fetchProcessedFile(fileId)
      .then((response) => {
        const link = document.createElement("a");
        link.href = response.signedUrl;
        link.click();
        openSnackbar("Processed File downloaded successfully!", "success");
      })
      .catch((error) => {
        console.error("Error fetching Processed File", error);
        openSnackbar(error.message || "Error fetching Processed File", "error");
      });
  } else {
    console.error("No File Id provided");
  }
};
const getHistoryTableRows = (
  history,
  fetchProcessedFile,
  openSnackbar,
  scriptId,
  isFetchProcessedFileLoading
) => {
  if (!Array.isArray(history)) {
    return [];
  }

  return history
    .filter((historyRowDetail) => historyRowDetail.script.id === scriptId)
    .map((historyRowDetail) => ({
      name: historyRowDetail.name,
      createdAt: new Date(historyRowDetail.created_at).toLocaleString(),
      totalRows: historyRowDetail.result?.total_rows,
      errorRows: historyRowDetail.result?.error_rows,
      status: historyRowDetail.status.name,
      downloadProcessedFile:
        historyRowDetail.status.id === FILE_UPLOAD_STATUS.PROCESSED ? (
          <PrimaryButton
            onClick={() =>
              handleOnClickDownloadProcessedFile(
                historyRowDetail.file_id,
                fetchProcessedFile,
                openSnackbar
              )
            }
          >
           {isFetchProcessedFileLoading ? "Loading...." : "Download"}
          </PrimaryButton>
        ) : (
          <PrimaryButton disabled>Not Available Yet</PrimaryButton>
        ),
    }));
};

const FileUploadsHistory = (props) => {
  const { scriptId } = props;
  const userId = tokenUtils.readUserId();
  const { openSnackbar } = useSnackbarContext();

  const {
    isPending: isHistoryLoading,
    data: history,
  } = useFetchHistory(userId);

  const { fetchProcessedFile, isLoading: isFetchProcessedFileLoading } =
    useFetchProcessedFile();

  if (isHistoryLoading) {
    return <Loader />;
  }

  const rows = getHistoryTableRows(
    history,
    fetchProcessedFile,
    openSnackbar,
    scriptId,
    isFetchProcessedFileLoading
  );

  return (
    <div className={styles.mainContainer}><Table columns={columns} rows={rows} /></div>
  );
};
export default FileUploadsHistory;
